import React from "react";

import { ThemeToggle } from "../ThemeToggle";

export const Header: React.FC = React.memo(() => {
  return (
    <header
      className="
      w-full bg-[#f0f2f5] text-[#1f1f1f] dark:bg-[#1a1a1a] dark:text-white 
      flex items-center justify-between 
      pt-[25px] pb-[20px] px-4 
      sm:pt-[24px] sm:pb-[24px] sm:px-6 
      md:pt-4 md:pb-4 
      border-b border-[#d4d7dd] dark:border-gray-700 shadow-lg z-40
    "
    >
      <div className="flex items-center gap-2">
        <img
          src="/images/logo_header/logo.png"
          alt="IQCRYPTO"
          className="w-[160px] sm:w-[150px] md:w-[200px] h-auto object-contain"
        />
      </div>

      <div className="hidden md:block">
        <ThemeToggle />
      </div>
    </header>
  );
});
